import { exportFilename, saveBlob } from "./table";
import type { ReportDoc } from "./pdf/model";

/** Draws a report and saves it as a PDF. The PDF library loads on the first call. */
export async function downloadReport(report: ReportDoc): Promise<string> {
  const { renderReport } = await import("./pdf/render");
  const filename = exportFilename(report.filename, ".pdf");
  saveBlob(renderReport(report), filename);
  return filename;
}
